// extracted by mini-css-extract-plugin
export default {"title":"Dsecond_title__mkcF9","desc":"Dsecond_desc__MTGbX","text":"Dsecond_text__UUtec","Dsecond":"Dsecond_Dsecond__XI1j1"};